import React from 'react'
import clsx from 'clsx'

export function Button({ variant='primary', size='md', className, ...props }) {
  const base = 'btn fw-medium'
  const v = variant === 'primary' ? 'btn-primary' : variant === 'outline' ? 'btn-outline-secondary' : 'btn-link text-decoration-none'
  const s = size === 'sm' ? 'btn-sm rounded' : 'rounded-3'
  return <button className={clsx(base, v, s, className)} {...props} />
}